import { Http } from "../axios/interceptors";

export const allProducts = async (param) =>
  Http("GET", `/Products/GetList?`, param);

export const allProductsByCompany = async (param) =>
  Http("GET", "/Products/GetByCompany?", param);

export const getProduct = async (guid) =>
  Http("GET", `/Products/Get?guid=${guid}`);

export const createOrEditProduct = async (body, id = null) =>
  id
    ? Http("PUT", `/Products/Update`, null, body)
    : Http("POST", "/Products/Create", null, body);

export const deleteProduct = async (guid) =>
  Http("PUT", `/Products/Inactive?guid=${guid}`);

export const allCateg = async () =>
  Http(
    "GET",
    `/Catalogs/Get?guidCatalog=1a7856c1-cd05-4cac-9e8e-dd87b4a907e5&itemsPage=1&itemsRows=1000`,
  );

export const categoryProductsByCompany = async (param) =>
  Http("GET", "/CategoryProducts/GetList?", param);

export const createProductExcel = async (files = null, guid) => {
  const formData = new FormData();

  formData.append("excelFile", files);

  return Http(
    "POST",
    `/Products/CreateFromExcel?GuidCompany=${guid}`,
    null,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};

export const postFileExcelValery = async (files = null, guid) => {
  const formData = new FormData();

  formData.append("excelFile", files);

  return Http(
    "POST",
    `/Products/CreateFromExcelSistemaValery?GuidCompany=${guid}`,
    null,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};
